var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd2 = function SvgAdd2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3E73A4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6 8.667h4m-2-2v4M11.333 14H4.667a1.333 1.333 0 0 1-1.334-1.333V3.333C3.333 2.597 3.93 2 4.667 2H8.39c.177 0 .347.07.472.195l3.61 3.61a.67.67 0 0 1 .195.471v6.39c0 .737-.597 1.334-1.334 1.334"
  })));
};
export default SvgAdd2;